import { Flex } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';
import { ReactNode } from 'react';

import './styles.scss';

export interface CallToActionSlideProps {
  children: ReactNode;
  className?: string;
}

const ContentSlide = ({ children, className }: CallToActionSlideProps) => (
  <Flex
    alignItems={{ mobile: 'start', tablet: 'center' }}
    justifyContent="center"
    className={clsx('content-slide', className)}
  >
    {children}
  </Flex>
);

export { ContentSlide };
